import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import Kpi from "@/models/Kpi";

export const InitState = () => ({
  kpi: new Kpi()
})

export default {
  namespaced: true,
  state: InitState,
  actions,
  mutations,
  getters
}
